import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    card_produto: {
        width: "504px",
        border: "1px solid #DBDBDB",
        borderRadius: "5px",
        margin: "0 auto 16px auto",
        padding: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    icons: {
        flexBasis: "0",
    },
    ids: {
        textAlign: "left",
    },
}));
